import React from 'react'
import style from './Carrusel.module.css'

import { useTranslation } from 'react-i18next'

import imagen1 from '../../utils/images/logos/1-Jumbo-400x400px.png'
import imagen2 from '../../utils/images/logos/3-Spid-400x400px.png'
import imagen3 from '../../utils/images/logos/4-Vea-400x400px.png'
import imagen4 from '../../utils/images/logos/5-Disco-400x400px.png'
import imagen5 from '../../utils/images/logos/12-Easy-400x400px.png'
import imagen6 from '../../utils/images/logos/15-Blaisten-400x400px.png'
import imagen7 from '../../utils/images/logos/18-ShoppingC-400x400px.png'

import imagen8 from '../../utils/images/logos/8-Gbarbosa-400x400px.png'
import imagen9 from '../../utils/images/logos/9-Mercantil-400x400px.png'
import imagen10 from '../../utils/images/logos/10-Bretas-400x400px.png'
import imagen11 from '../../utils/images/logos/10-Perini-400x400px.png'
import imagen12 from '../../utils/images/logos/11-Prezunic-400x400px.png'
import imagen13 from '../../utils/images/logos/7-Giga-400x400px.png'

import imagen14 from '../../utils/images/logos/Andreu-rojo.png'
import imagen15 from '../../utils/images/logos/bw-group.jpg'
import imagen16 from '../../utils/images/logos/ConectarIgualdad.png'
import imagen17 from '../../utils/images/logos/dynamic.png'
import imagen18 from '../../utils/images/logos/gottert.png'
import imagen19 from '../../utils/images/logos/globant.png'
import imagen20 from '../../utils/images/logos/Inmark.jpg'
import imagen21 from '../../utils/images/logos/Inxpirius.png'
import imagen22 from '../../utils/images/logos/iupix.png'
import imagen23 from '../../utils/images/logos/LogoConcreta.png'
import imagen24 from '../../utils/images/logos/LogoGrafmaq.png'
import imagen25 from '../../utils/images/logos/LogoPiana.png'
import imagen26 from '../../utils/images/logos/Procrear_Bicentenario_Argentina_84d7e_450x450.png'
import imagen27 from '../../utils/images/logos/progresar.png'
import imagen28 from '../../utils/images/logos/Second Skin.png'
import imagen29 from '../../utils/images/logos/zaxera.png'
import imagen30 from '../../utils/images/logos/zetti.png'



const Carrusel = () => {
  const [t] = useTranslation();

  const logos = [
    imagen1, imagen2, imagen3, imagen4, imagen5, imagen6, imagen7, imagen8,
    imagen9, imagen10, imagen11, imagen12, imagen13, imagen14, imagen15,
    imagen16, imagen17, imagen18, imagen19, imagen20, imagen21, imagen22,
    imagen23, imagen24, imagen25, imagen26, imagen27, imagen28, imagen29, imagen30
  ];

  return (
    <div className={style.clientes}>
      <p className={style.nuestroC}>
        {t("HomePage.Customers.some-of-our-customers")}
      </p>
      <div className={style.separador}></div>

      <div className={style.carrusel}>
        <div className={style.divPaginas}>
          {logos.map((src, idx) => (
            <img
              key={idx}
              src={src}
              className={style.imagen}
              alt={`logo-${idx}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carrusel;